// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { format } from 'date-fns';
// import Select from 'react-select';
// import { saveAs } from 'file-saver';
// import "react-datepicker/dist/react-datepicker.css";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import TextField from "@mui/material/TextField";
// import dayjs from "dayjs";

// const CashFlowStatement = () => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [projects, setProjects] = useState([]);
//     const [filters, setFilters] = useState({
//         start_date: '',
//         end_date: '',
//         project_id: '',
//         include_non_cash: false
//     });
//     const [summary, setSummary] = useState(null);

//     const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
//     const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
//     const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;




//     // Fetch projects on component mount
//     useEffect(() => {
//         const fetchProjects = async () => {
//             try {
//                 const userInfo = JSON.parse(localStorage.getItem("user-info"));
//                 const origin = localStorage.getItem('user-origin');
//                 const token = userInfo?.token;

//                 const projectsResponse = await axios.get(`${API_ORIGIN}/api/projects`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     }
//                 });

//                 setProjects(projectsResponse.data?.Data?.map(project => ({
//                     value: project.id,
//                     label: project.name
//                 })));

//             } catch (err) {
//                 setError('Failed to load projects');
//                 console.error('Projects error:', err);
//             }
//         };

//         fetchProjects();
//     }, [API_ORIGIN]);

//     const fetchCashFlowStatement = async () => {
//         setLoading(true);
//         setError(null);

//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('start_date', filters.start_date);
//             if (filters.end_date) params.append('end_date', filters.end_date);
//             if (filters.project_id) params.append('project_id', filters.project_id);
//             params.append('include_non_cash', filters.include_non_cash);

//             console.log("Fetching cash flow with params:", {
//                 start_date: filters.start_date,
//                 end_date: filters.end_date,
//                 project_id: filters.project_id,
//                 url: `${API_BASE_URL}/api/reports/cashflow?${params.toString()}`
//             });

//             // Fetch cash transactions
//             const cashResponse = await axios.get(
//                 `${API_BASE_URL}/api/reports/cashflow`,
//                 {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': 'application/json',
//                     },
//                     params
//                 }
//             );

//             console.log("Cash flow API response:", cashResponse.data);

//             if (cashResponse.data.status === 'success') {
//                 const cashData = cashResponse.data.data;

//                 // If no transactions found, show message
//                 if (cashData.cash_transactions_count === 0) {
//                     setError('No cash transactions found in the selected period. Please check: 1) Date range, 2) Cash ledger configuration');
//                     setData(null);
//                     setSummary(null);
//                 } else {
//                     // Calculate summary from the backend data
//                     const cashSummary = {
//                         opening_balance: cashData.summary.opening_balance || 0,
//                         net_operating: cashData.summary.net_operating || 0,
//                         net_investing: cashData.summary.net_investing || 0,
//                         net_financing: cashData.summary.net_financing || 0,
//                         net_cash_flow: cashData.summary.net_cash_flow || 0,
//                         closing_balance: cashData.summary.closing_balance || 0,
//                         total_inflows: cashData.summary.total_inflows || 0,
//                         total_outflows: cashData.summary.total_outflows || 0
//                     };

//                     setData(cashData);
//                     setSummary(cashSummary);
//                 }
//             } else {
//                 setError(cashResponse.data.message || 'Failed to fetch cash flow statement');
//             }

//         } catch (err) {
//             console.error("Cash flow API error:", err);
//             setError(err.response?.data?.message || err.message || 'Failed to fetch cash flow statement');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         fetchCashFlowStatement();
//     };

//     const handleClear = () => {
//         setFilters({
//             start_date: '',
//             end_date: '',
//             project_id: '',
//             include_non_cash: false
//         });
//         setData(null);
//         setSummary(null);
//     };

//     const handleExport = async (formatType) => {
//         try {
//             const params = new URLSearchParams();
//             if (filters.start_date) params.append('start_date', filters.start_date);
//             if (filters.end_date) params.append('end_date', filters.end_date);
//             if (filters.project_id) params.append('project_id', filters.project_id);
//             params.append('format', formatType);

//             const response = await axios.get(
//                 `${API_BASE_URL}/api/reports/cashflow`,
//                 {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         'Accept': 'application/octet-stream'
//                     },
//                     params,
//                     responseType: 'blob'
//                 }
//             );
//             const blob = new Blob([response.data], { type: response.headers['content-type'] });

//             const extension = formatType === 'csv' ? 'csv' : 'xls';
//             saveAs(blob, `cash_flow_statement_${filters.start_date || 'start'}_to_${filters.end_date || 'end'}.${extension}`);
//         } catch (err) {
//             setError(`Failed to export ${formatType.toUpperCase()}`);
//             console.error('Export Error:', err);
//         }
//     };

//     // Format amount with proper sign
//     const formatAmount = (amount) => {
//         const numAmount = parseFloat(amount || 0);
//         const formatted = Math.abs(numAmount).toLocaleString('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });

//         if (numAmount >= 0) {
//             return formatted;
//         } else {
//             return `(${formatted})`;
//         }
//     };

//     // Get amount display class
//     const getAmountClass = (amount) => {
//         const numAmount = parseFloat(amount || 0);
//         if (numAmount > 0) return 'text-success';
//         if (numAmount < 0) return 'text-danger';
//         return 'text-muted';
//     };

//     // Calculate cash received from customers
// const calculateOperatingCashIn = (data) => {
//     if (!data?.activities?.operating?.transactions) return 0;

//     return data.activities.operating.transactions
//         .filter(t => t.is_inflow && t.counterparty_group === 'Accounts Receivable')
//         .reduce((sum, t) => sum + t.amount, 0);
// };

// // Calculate cash paid to suppliers
// const calculateOperatingSuppliersOut = (data) => {
//     if (!data?.activities?.operating?.transactions) return 0;

//     return data.activities.operating.transactions
//         .filter(t => !t.is_inflow && t.counterparty_group === 'Sundry Creditors (Vendors)')
//         .reduce((sum, t) => sum + t.amount, 0);
// };

// // Calculate operating expenses
// const calculateOperatingExpensesOut = (data) => {
//     if (!data?.activities?.operating?.transactions) return 0;

//     return data.activities.operating.transactions
//         .filter(t => !t.is_inflow && t.counterparty_group === 'Loans (Liabilities)')
//         .reduce((sum, t) => sum + t.amount, 0);
// };

// // Calculate capital introduced
// const calculateFinancingCapital = (data) => {
//     if (!data?.activities?.financing?.transactions) return 0;

//     return data.activities.financing.transactions
//         .filter(t => t.is_inflow && t.counterparty_group === 'Capital Account')
//         .reduce((sum, t) => sum + t.amount, 0);
// };

//     return (
//         <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-flex align-items-center justify-content-between">
//                                 <div>
//                                     <h4 className="mb-0 text-primary">Cash Flow Statement</h4>
//                                     <p className="text-muted mb-0 small">
//                                         Shows actual cash movement - Why you have profit but no cash
//                                     </p>
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item"><a href="#">Reports</a></li>
//                                         <li className="breadcrumb-item active">Cash Flow Statement</li>
//                                     </ol>
//                                 </div>
//                                 <div className="d-flex gap-2">
//                                     <button
//                                         onClick={() => handleExport('csv')}
//                                         className="btn btn-outline-primary btn-sm"
//                                         disabled={loading || !data}
//                                     >
//                                         <i className="fas fa-file-csv me-1"></i> CSV
//                                     </button>
//                                     <button
//                                         onClick={() => handleExport('xls')}
//                                         className="btn btn-outline-success btn-sm"
//                                         disabled={loading || !data}
//                                     >
//                                         <i className="fas fa-file-excel me-1"></i> Excel
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>


//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card shadow-sm">
//                                 <div className="card-header bg-white border-bottom">
//                                     <h5 className="card-title mb-0 text-primary">
//                                         <i className="fas fa-money-bill-wave me-2"></i>
//                                         Cash Flow Statement
//                                     </h5>
//                                 </div>

//                                 <div className="card-body">
//                                     <form onSubmit={handleSubmit} className="mb-4">
//                                         <div className="row g-3">
//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">From Date</label>

//                                                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                                     <DatePicker
//                                                         views={["year", "month", "day"]}
//                                                         density="compact"
//                                                         format="DD-MM-YYYY"
//                                                         value={
//                                                             filters.start_date && dayjs(filters.start_date).isValid()
//                                                                 ? dayjs(filters.start_date)
//                                                                 : null
//                                                         }
//                                                         onChange={(newValue) => {
//                                                             setFilters({
//                                                                 ...filters,
//                                                                 start_date:
//                                                                     newValue && newValue.isValid()
//                                                                         ? newValue.format("YYYY-MM-DD")
//                                                                         : null,
//                                                             });
//                                                         }}
//                                                         slotProps={{
//                                                             textField: {
//                                                                 size: "small",
//                                                                 fullWidth: true,
//                                                             },
//                                                             popper: {
//                                                                 sx: {
//                                                                     "& .MuiPaper-root": {
//                                                                         fontSize: "0.7rem",
//                                                                         minWidth: 260,
//                                                                     },
//                                                                 },
//                                                             },
//                                                         }}
//                                                     />




//                                                 </LocalizationProvider>
//                                             </div>
//                                             <div className="col-md-2">
//                                                 <label className="form-label text-muted small mb-1">To Date</label>

//                                                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                                     <DatePicker
//                                                         views={["year", "month", "day"]}
//                                                         format="DD-MM-YYYY"
//                                                         value={
//                                                             filters.end_date && dayjs(filters.end_date).isValid()
//                                                                 ? dayjs(filters.end_date)
//                                                                 : null
//                                                         } onChange={(newValue) => {
//                                                             setFilters({
//                                                                 ...filters,
//                                                                 end_date:
//                                                                     newValue && newValue.isValid()
//                                                                         ? newValue.format("YYYY-MM-DD")
//                                                                         : null,
//                                                             });
//                                                         }}
//                                                         density="compact"
//                                                         slotProps={{
//                                                             textField: {
//                                                                 size: "small",
//                                                                 fullWidth: true,
//                                                                 sx: {
//                                                                     "& input": {
//                                                                         fontSize: "0.65rem",
//                                                                         padding: "4px 6px",
//                                                                     },
//                                                                 },
//                                                             },
//                                                             popper: {
//                                                                 sx: {
//                                                                     "& .MuiPaper-root": {
//                                                                         fontSize: "0.65rem",
//                                                                         minWidth: 100,   // 🔑 do NOT go below this
//                                                                     },
//                                                                 },
//                                                             },
//                                                         }}
//                                                     />
//                                                 </LocalizationProvider>
//                                             </div>

//                                             <div className="col-md-3">
//                                                 <label className="form-label text-muted small mb-1">Project (Optional)</label>
//                                                 <Select
//                                                     options={projects}
//                                                     value={projects.find(option => option.value === filters.project_id)}
//                                                     onChange={(selected) => setFilters({ ...filters, project_id: selected?.value || '' })}
//                                                     isClearable
//                                                     placeholder="Select Project..."
//                                                     className="border-primary"
//                                                     styles={{
//                                                         control: (base) => ({
//                                                             ...base,
//                                                             minHeight: '38px'
//                                                         })
//                                                     }}
//                                                 />
//                                             </div>


//                                             <div className="col-md-12 mt-3">
//                                                 <button
//                                                     type="submit"
//                                                     className="btn btn-primary me-2 px-4"
//                                                     disabled={loading || !filters.start_date || !filters.end_date}
//                                                 >
//                                                     {loading ? (
//                                                         <>
//                                                             <span className="spinner-border spinner-border-sm me-1" role="status"></span>
//                                                             Generating...
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <i className="fas fa-chart-line me-1"></i>
//                                                             Generate Cash Flow
//                                                         </>
//                                                     )}
//                                                 </button>
//                                                 <button
//                                                     type="button"
//                                                     className="btn btn-outline-secondary px-4"
//                                                     onClick={handleClear}
//                                                     disabled={loading}
//                                                 >
//                                                     <i className="fas fa-eraser me-1"></i>
//                                                     Clear
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </form>

//                                     {error && (
//                                         <div className="alert alert-danger alert-dismissible fade show" role="alert">
//                                             <i className="fas fa-exclamation-circle me-2"></i>
//                                             {error}
//                                             <button type="button" className="btn-close" onClick={() => setError(null)}></button>
//                                         </div>
//                                     )}

//                                     {loading && !data && (
//                                         <div className="text-center py-5">
//                                             <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
//                                                 <span className="visually-hidden">Loading...</span>
//                                             </div>
//                                             <p className="mt-3 text-muted">Analyzing cash movements...</p>
//                                         </div>
//                                     )}

//                                     {!loading && summary && (
//                                         <div className="mt-4">
//                                             {/* Period Info */}
//                                             <div className="d-flex justify-content-between align-items-center mb-4">
//                                                 <div>
//                                                     <h5 className="text-primary mb-1">
//                                                         <i className="fas fa-calendar-alt me-2"></i>
//                                                         Cash Flow Statement
//                                                     </h5>
//                                                     <div className="text-muted small">
//                                                         Period: {filters.start_date ? format(new Date(filters.start_date), 'MMM dd, yyyy') : ''}
//                                                         {' to '}
//                                                         {filters.end_date ? format(new Date(filters.end_date), 'MMM dd, yyyy') : ''}
//                                                     </div>
//                                                 </div>
//                                                 <div className={`badge ${summary.net_cash_flow >= 0 ? 'bg-success' : 'bg-danger'}`}>
//                                                     Net Cash Flow: {formatAmount(summary.net_cash_flow)}
//                                                 </div>
//                                             </div>

//                                             {/* Cash Flow Summary Cards */}
//                                             <div className="row mb-4">
//                                                 <div className="col-md-3">
//                                                     <div className="card border">
//                                                         <div className="card-body p-3 text-center">
//                                                             <h6 className="card-title text-muted small mb-1">Opening Cash</h6>
//                                                             <div className={`h4 mb-0 ${getAmountClass(summary.opening_balance)}`}>
//                                                                 {formatAmount(summary.opening_balance)}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-3">
//                                                     <div className="card border">
//                                                         <div className="card-body p-3 text-center">
//                                                             <h6 className="card-title text-muted small mb-1">
//                                                                 <span className="badge bg-light me-1">A</span> Operating
//                                                             </h6>
//                                                             <div className={`h4 mb-0 ${getAmountClass(summary.net_operating)}`}>
//                                                                 {formatAmount(summary.net_operating)}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-3">
//                                                     <div className="card border">
//                                                         <div className="card-body p-3 text-center">
//                                                             <h6 className="card-title text-muted small mb-1">
//                                                                 <span className="badge bg-light me-1">B</span> Investing
//                                                             </h6>
//                                                             <div className={`h4 mb-0 ${getAmountClass(summary.net_investing)}`}>
//                                                                 {formatAmount(summary.net_investing)}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-3">
//                                                     <div className="card border">
//                                                         <div className="card-body p-3 text-center">
//                                                             <h6 className="card-title text-muted small mb-1">
//                                                                 <span className="badge bg-light me-1">C</span> Financing
//                                                             </h6>
//                                                             <div className={`h4 mb-0 ${getAmountClass(summary.net_financing)}`}>
//                                                                 {formatAmount(summary.net_financing)}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {/* Detailed Cash Flow Statement */}
//                                             <div className="table-responsive">
//                                                 <table className="table table-hover align-middle">
//                                                     <thead className="table-sales-gradient">
//                                                         <tr>
//                                                             <th style={{ width: '5%' }}>#</th>
//                                                             <th style={{ width: '45%' }}>Description</th>
//                                                             <th style={{ width: '25%' }} className="text-end">Cash Inflows</th>
//                                                             <th style={{ width: '25%' }} className="text-end">Cash Outflows</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {/* A. OPERATING ACTIVITIES */}
//                                                         <tr>
//                                                             <td colSpan="4" className="fw-bold">
//                                                                 <i className="fas fa-store me-2"></i>
//                                                                 A. CASH FLOW FROM OPERATING ACTIVITIES
//                                                             </td>
//                                                         </tr>

//                                                  // In your JSX table, replace these lines:

// {/* Cash from customers */}
// <tr>
//     <td>1</td>
//     <td>
//         <i className="fas fa-user-check text-success me-2"></i>
//         Cash received from customers
//     </td>
//     <td className="text-end text-success fw-bold">
//         {calculateOperatingCashIn(data) || '0.00'}
//     </td>
//     <td className="text-end"></td>
// </tr>

// {/* Cash paid to suppliers */}
// <tr>
//     <td>2</td>
//     <td>
//         <i className="fas fa-truck text-danger me-2"></i>
//         Cash paid to suppliers
//     </td>
//     <td className="text-end"></td>
//     <td className="text-end text-danger fw-bold">
//         {calculateOperatingSuppliersOut(data) || '0.00'}
//     </td>
// </tr>

// {/* Operating expenses */}
// <tr>
//     <td>3</td>
//     <td>
//         <i className="fas fa-file-invoice-dollar text-danger me-2"></i>
//         Operating expenses paid
//     </td>
//     <td className="text-end"></td>
//     <td className="text-end text-danger fw-bold">
//         {calculateOperatingExpensesOut(data) || '0.00'}
//     </td>
// </tr>

//                                                         {/* Net Operating Cash Flow */}
//                                                         <tr className="fw-bold bg-light">
//                                                             <td></td>
//                                                             <td className="text-end">Net Cash from Operating Activities</td>
//                                                             <td className={`text-end ${getAmountClass(summary.net_operating)}`} colSpan="2">
//                                                                 {formatAmount(summary.net_operating)}
//                                                             </td>
//                                                         </tr>

//                                                         {/* B. INVESTING ACTIVITIES */}
//                                                         <tr>
//                                                             <td colSpan="4" className="fw-bold">
//                                                                 <i className="fas fa-chart-line me-2"></i>
//                                                                 B. CASH FLOW FROM INVESTING ACTIVITIES
//                                                             </td>
//                                                         </tr>

//                                                         {/* Sale of assets */}
//                                                         <tr>
//                                                             <td>4</td>
//                                                             <td>
//                                                                 <i className="fas fa-building text-success me-2"></i>
//                                                                 Sale of fixed assets
//                                                             </td>
//                                                             <td className="text-end text-success fw-bold">
//                                                                 {data?.investing_activities?.cash_in?.assets_sale ?
//                                                                     formatAmount(data.investing_activities.cash_in.assets_sale) : '0.00'}
//                                                             </td>
//                                                             <td className="text-end"></td>
//                                                         </tr>

//                                                         {/* Purchase of assets */}
//                                                         <tr>
//                                                             <td>5</td>
//                                                             <td>
//                                                                 <i className="fas fa-tools text-danger me-2"></i>
//                                                                 Purchase of fixed assets
//                                                             </td>
//                                                             <td className="text-end"></td>
//                                                             <td className="text-end text-danger fw-bold">
//                                                                 {data?.investing_activities?.cash_out?.assets_purchase ?
//                                                                     formatAmount(data.investing_activities.cash_out.assets_purchase) : '0.00'}
//                                                             </td>
//                                                         </tr>

//                                                         {/* Net Investing Cash Flow */}
//                                                         <tr className="fw-bold bg-light">
//                                                             <td></td>
//                                                             <td className="text-end">Net Cash from Investing Activities</td>
//                                                             <td className={`text-end ${getAmountClass(summary.net_investing)}`} colSpan="2">
//                                                                 {formatAmount(summary.net_investing)}
//                                                             </td>
//                                                         </tr>

//                                                         {/* C. FINANCING ACTIVITIES */}
//                                                         <tr>
//                                                             <td colSpan="4" className="fw-bold">
//                                                                 <i className="fas fa-hand-holding-usd me-2"></i>
//                                                                 C. CASH FLOW FROM FINANCING ACTIVITIES
//                                                             </td>
//                                                         </tr>

//                                                         {/* Capital introduced */}
//                                                         <tr>
//                                                             <td>6</td>
//                                                             <td>
//                                                                 <i className="fas fa-user-plus text-success me-2"></i>
//                                                                 Capital introduced by owners
//                                                             </td>
//                                                             <td className="text-end text-success fw-bold">
//                                                                 {data?.financing_activities?.cash_in?.capital ?
//                                                                     formatAmount(data.financing_activities.cash_in.capital) : '0.00'}
//                                                             </td>
//                                                             <td className="text-end"></td>
//                                                         </tr>

//                                                         {/* Loan received */}
//                                                         <tr>
//                                                             <td>7</td>
//                                                             <td>
//                                                                 <i className="fas fa-university text-success me-2"></i>
//                                                                 Loans received
//                                                             </td>
//                                                             <td className="text-end text-success fw-bold">
//                                                                 {data?.financing_activities?.cash_in?.loans ?
//                                                                     formatAmount(data.financing_activities.cash_in.loans) : '0.00'}
//                                                             </td>
//                                                             <td className="text-end"></td>
//                                                         </tr>

//                                                         {/* Loan repayment */}
//                                                         <tr>
//                                                             <td>8</td>
//                                                             <td>
//                                                                 <i className="fas fa-hand-holding-usd text-danger me-2"></i>
//                                                                 Loan repayments
//                                                             </td>
//                                                             <td className="text-end"></td>
//                                                             <td className="text-end text-danger fw-bold">
//                                                                 {data?.financing_activities?.cash_out?.loan_repayment ?
//                                                                     formatAmount(data.financing_activities.cash_out.loan_repayment) : '0.00'}
//                                                             </td>
//                                                         </tr>

//                                                         {/* Net Financing Cash Flow */}
//                                                         <tr className="fw-bold bg-light">
//                                                             <td></td>
//                                                             <td className="text-end">Net Cash from Financing Activities</td>
//                                                             <td className={`text-end ${getAmountClass(summary.net_financing)}`} colSpan="2">
//                                                                 {formatAmount(summary.net_financing)}
//                                                             </td>
//                                                         </tr>

//                                                         {/* SUMMARY */}
//                                                         <tr>
//                                                             <td colSpan="4" className="fw-bold">
//                                                                 <i className="fas fa-calculator me-2"></i>
//                                                                 SUMMARY
//                                                             </td>
//                                                         </tr>

//                                                         <tr className="fw-bold">
//                                                             <td>9</td>
//                                                             <td>Net Cash Flow (A + B + C)</td>
//                                                             <td className={`text-end ${getAmountClass(summary.net_cash_flow)}`} colSpan="2">
//                                                                 {formatAmount(summary.net_cash_flow)}
//                                                             </td>
//                                                         </tr>

//                                                         <tr className="fw-bold">
//                                                             <td>10</td>
//                                                             <td>Opening Cash Balance</td>
//                                                             <td className={`text-end ${getAmountClass(summary.opening_balance)}`} colSpan="2">
//                                                                 {formatAmount(summary.opening_balance)}
//                                                             </td>
//                                                         </tr>

//                                                         <tr className="fw-bold">
//                                                             <td>11</td>
//                                                             <td>Closing Cash Balance</td>
//                                                             <td className={`text-end ${getAmountClass(summary.closing_balance)}`} colSpan="2">
//                                                                 {formatAmount(summary.closing_balance)}
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </table>
//                                             </div>

//                                             {/* Explanation Section */}
//                                             {/* <div className="card border-0 bg-light mt-4">
//                                                 <div className="card-body">
//                                                     <h6 className="text-primary mb-3">
//                                                         <i className="fas fa-lightbulb me-2"></i>
//                                                         How to Interpret This Statement
//                                                     </h6>
//                                                     <div className="row">
//                                                         <div className="col-md-4">
//                                                             <div className="card border mb-3">
//                                                                 <div className="card-body">
//                                                                     <h6 className="card-title text-primary">
//                                                                         <span className="badge bg-primary me-2">Positive</span>
//                                                                         Operating Cash Flow
//                                                                     </h6>
//                                                                     <p className="small mb-0">
//                                                                         Business is generating enough cash from core operations. Healthy sign!
//                                                                     </p>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-md-4">
//                                                             <div className="card border mb-3">
//                                                                 <div className="card-body">
//                                                                     <h6 className="card-title text-info">
//                                                                         <span className="badge bg-info me-2">Negative</span>
//                                                                         Investing Cash Flow
//                                                                     </h6>
//                                                                     <p className="small mb-0">
//                                                                         Company is investing in assets for future growth. Normal for growing businesses.
//                                                                     </p>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-md-4">
//                                                             <div className="card border mb-3">
//                                                                 <div className="card-body">
//                                                                     <h6 className="card-title text-warning">
//                                                                         <span className="badge bg-warning me-2">Watch</span>
//                                                                         Financing Cash Flow
//                                                                     </h6>
//                                                                     <p className="small mb-0">
//                                                                         Positive: Raising funds. Negative: Paying debts or dividends.
//                                                                     </p>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div> */}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default CashFlowStatement;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import Select from 'react-select';
import { saveAs } from 'file-saver';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { getAdjustedStartDate, getAdjustedEndDate } from '../../utils/dateHelper';

const CashFlowStatement = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [projects, setProjects] = useState([]);
    const [filters, setFilters] = useState({
        start_date: '',
        end_date: '',
        project_id: '',
        include_non_cash: false,
        dateRange: 'yearly'
    });
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedEndYear, setSelectedEndYear] = useState(null);

    const handleDateRangeChange = (value) => {
        setFilters(prev => ({ ...prev, dateRange: value }));
        if (value === 'yearly') {
            setSelectedYear(null);
            setSelectedEndYear(null);
            setFilters(prev => ({ ...prev, start_date: '', end_date: '' }));
        }
    };
    // Define exact group names for categorization (better maintainability)
    const CATEGORY_GROUPS = {
        RECEIVABLE: [
            'Accounts Receivable',
            'Sundry Debtors'
        ],
        SUPPLIERS: [
            'Sundry Creditors',
            'Sundry Creditors (Vendors)',
            'Accounts Payable'
        ],
        OPERATING_EXPENSES: [
            'Direct Expenses',
            'Indirect Expenses',
            'Expenses',
            'Operating Expenses'
        ],
        EMPLOYEES: [
            'Salary & Wages',
            'Employee Salaries',
            'Staff Costs',
            'Loans (Liabilities)',
            'Loans and Advances (Asset)'
        ],
        FIXED_ASSETS: [
            'Fixed Assets',
            
        ],
        CAPITAL: [
            "Owner's Capital",
        ],
        DRAWINGS: [
            'Drawings',
            "Owner's Drawings"
        ]
    };

    // Helper function to check if a transaction matches a category by group name
    const matchesCategory = (transaction, groupNames, isExpenseCategory = false, isEmployeeCategory = false, isAssetCategory = false, isCapitalCategory = false, isDrawingCategory = false) => {
        const groupName = (transaction.counterparty_group || '').toLowerCase();
        const parentGroupName = (transaction.counterparty_parent_group || '').toLowerCase();
        const ledgerName = (transaction.counterparty_ledger || '').toLowerCase();
        const narration = (transaction.narration || '').toLowerCase();

        // 1. Check for exact group name match in the provided list
        const exactMatch = groupNames?.some(name =>
            groupName === name.toLowerCase() ||
            parentGroupName === name.toLowerCase()
        );

        if (exactMatch) return true;

        // 2. Dynamic Employee Categorization:
        if (isEmployeeCategory) {
            const hasEmployeeKeyword =
                groupName.includes('employee') || parentGroupName.includes('employee') || ledgerName.includes('employee') ||
                groupName.includes('salary') || parentGroupName.includes('salary') || ledgerName.includes('salary') ||
                groupName.includes('wage') || parentGroupName.includes('wage') || ledgerName.includes('wage') ||
                groupName.includes('staff') || parentGroupName.includes('staff') || ledgerName.includes('staff') ||
                groupName.includes('payroll') || parentGroupName.includes('payroll') || ledgerName.includes('payroll') ||
                ledgerName.includes('bonus') || ledgerName.includes('commission') || ledgerName.includes('allowance') ||
                ledgerName.includes('petty') || narration.includes('petty');

            return hasEmployeeKeyword;
        }

        // 3. Dynamic Asset Categorization:
        if (isAssetCategory) {
            return (
                groupName.includes('asset') || parentGroupName.includes('asset') || ledgerName.includes('asset') ||
                groupName.includes('investment') || parentGroupName.includes('investment') || ledgerName.includes('investment') ||
                ledgerName.includes('building') || ledgerName.includes('vehicle') || ledgerName.includes('machine') ||
                ledgerName.includes('computer') || ledgerName.includes('furniture') || ledgerName.includes('equipment')
            );
        }

        // 4. Dynamic Capital Categorization:
        if (isCapitalCategory) {
            return (
                groupName.includes('capital') || parentGroupName.includes('capital') || ledgerName.includes('capital') ||
                groupName.includes('equity') || parentGroupName.includes('equity') || ledgerName.includes('equity')
            );
        }

        // 5. Dynamic Drawing Categorization:
        if (isDrawingCategory) {
            return (
                groupName.includes('drawing') || parentGroupName.includes('drawing') || ledgerName.includes('drawing') ||
                groupName.includes('withdrawal') || parentGroupName.includes('withdrawal') || ledgerName.includes('withdrawal')
            );
        }

        // 6. Dynamic Expense Categorization:
        if (isExpenseCategory) {
            const isLiability = groupName.includes('liability') || parentGroupName.includes('liability');
            const hasExpenseKeyword = groupName.includes('expense') || parentGroupName.includes('expense');
            const isPurchaseAccount = groupName.includes('purchase') || parentGroupName.includes('purchase');

            return (hasExpenseKeyword || isPurchaseAccount) && !isLiability;
        }

        return false;
    };

    const API_BASE_URL = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
    const API_KEY = process.env.REACT_APP_API_KEY || 'your_api_key_here';
    const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

    // Fetch projects on component mount
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const projectsResponse = await axios.get(`${API_ORIGIN}/api/projects`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    }
                });

                setProjects(projectsResponse.data?.Data?.map(project => ({
                    value: project.id,
                    label: project.name
                })));

            } catch (err) {
                setError('Failed to load projects');
                console.error('Projects error:', err);
            }
        };

        fetchProjects();
    }, [API_ORIGIN]);

    const fetchCashFlowStatement = async () => {
        setLoading(true);
        setError(null);

        try {
            const params = new URLSearchParams();
            if (filters.start_date) params.append('start_date', filters.start_date);
            if (filters.end_date) params.append('end_date', filters.end_date);
            if (filters.project_id) params.append('project_id', filters.project_id);
            params.append('include_non_cash', filters.include_non_cash);

            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const token = userInfo?.token;

            // Fetch cash transactions
            const cashResponse = await axios.get(
                `${API_ORIGIN}/api/reports/cashflow`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept': 'application/json',
                    },
                    params
                }
            );

            if (cashResponse.data.status === 'success') {
                const cashData = cashResponse.data.data;
                setData(cashData);
            } else {
                setError(cashResponse.data.message || 'Failed to fetch cash flow statement');
            }

        } catch (err) {
            console.error("Cash flow API error:", err);
            setError(err.response?.data?.message || err.message || 'Failed to fetch cash flow statement');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!data?.activities?.operating?.transactions) return;

        console.group("🔎 Cash Flow Operating Transactions Debug");

        // Show group configuration
        console.log("📋 Category Groups:", CATEGORY_GROUPS);

        // Categorize and log each transaction
        const categorized = {
            customers: [],
            employees: [],
            suppliers: [],
            other: [] // We'll still log "other" for debugging but it will be merged in UI
        };

        data.activities.operating.transactions.forEach((t, i) => {
            const isCustomer = t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.RECEIVABLE);
            const isEmployee = !t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.EMPLOYEES, false, true);

            // All other outflows (Suppliers, Expenses, VAT, etc.) go to Suppliers
            const isOutflow = !t.is_inflow;
            const isSupplier = isOutflow && !isEmployee;

            const txInfo = {
                index: i + 1,
                is_inflow: t.is_inflow,
                amount: t.amount,
                counterparty_ledger: t.counterparty_ledger,
                counterparty_group: t.counterparty_group,
                counterparty_group_id: t.counterparty_group_id,
                counterparty_parent_group: t.counterparty_parent_group,
                narration: t.narration
            };

            if (isCustomer) categorized.customers.push(txInfo);
            else if (isEmployee) categorized.employees.push(txInfo);
            else if (isSupplier) categorized.suppliers.push(txInfo);
            else categorized.other.push(txInfo); // Other inflows (rare)
        });

        console.log(`✅ Cash from Customers (All Inflows) (${categorized.customers.length}):`, categorized.customers);
        console.log(`👥 Cash to Employees (${categorized.employees.length}):`, categorized.employees);
        console.log(`🚚 Cash to Suppliers (All other Outflows) (${categorized.suppliers.length}):`, categorized.suppliers);
        if (categorized.other.length > 0) console.log(`❓ Other Inflows:`, categorized.other);

        // Show unique group IDs found
        const uniqueGroupIds = [...new Set(data.activities.operating.transactions.map(t => t.counterparty_group_id))];
        const uniqueGroups = [...new Set(data.activities.operating.transactions.map(t => t.counterparty_group))];
        console.log("🔢 Unique Group IDs found:", uniqueGroupIds);
        console.log("📛 Unique Group Names found:", uniqueGroups);

        console.groupEnd();
    }, [data]);

    // ========== CALCULATION FUNCTIONS ==========

    // Calculate cash received from customers (using group name matching)
    const calculateCashFromCustomers = () => {
        if (!data?.activities?.operating?.transactions) return 0;
        return data.activities.operating.transactions
            .filter(t => t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.RECEIVABLE))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    const calculateCashToEmployees = () => {
        if (!data?.activities?.operating?.transactions) return 0;
        return data.activities.operating.transactions
            .filter(t => !t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.EMPLOYEES, false, true))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    const calculateCashToSuppliers = () => {
        if (!data?.activities?.operating?.transactions) return 0;

        // 1. Base operating outflows (not employees)
        let total = data.activities.operating.transactions
            .filter(t => !t.is_inflow && !matchesCategory(t, CATEGORY_GROUPS.EMPLOYEES, false, true))
            .reduce((sum, t) => sum + t.amount, 0);

        // 2. Add non-asset investing outflows (e.g. VAT on assets or other charges)
        if (data?.activities?.investing?.transactions) {
            total += data.activities.investing.transactions
                .filter(t => !t.is_inflow && !matchesCategory(t, CATEGORY_GROUPS.FIXED_ASSETS, false, false, true))
                .reduce((sum, t) => sum + t.amount, 0);
        }

        // 3. Add non-asset financing outflows (if any)
        // ... optional, but focusing on what user reported for now

        return total;
    };


    // Calculate capital introduced by owner
    const calculateCapitalIntroduced = () => {
        if (!data?.activities?.financing?.transactions) return 0;

        return data.activities.financing.transactions
            .filter(t => t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.CAPITAL, false, false, false, true, false))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    // Calculate withdrawal of capital (Drawings)
    const calculateDrawings = () => {
        if (!data?.activities?.financing?.transactions) return 0;

        return data.activities.financing.transactions
            .filter(t => !t.is_inflow && (
                matchesCategory(t, CATEGORY_GROUPS.DRAWINGS, false, false, false, false, true) ||
                matchesCategory(t, CATEGORY_GROUPS.CAPITAL, false, false, false, true, false)
            ))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    // Calculate other loans received (Financing inflows that are NOT Capital)
    const calculateLoansReceived = () => {
        if (!data?.activities?.financing?.transactions) return 0;

        return data.activities.financing.transactions
            .filter(t => t.is_inflow && !matchesCategory(t, CATEGORY_GROUPS.CAPITAL, false, false, false, true, false))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    // Calculate other loan repayments (Financing outflows that are NOT Drawings)
    const calculateLoanRepayments = () => {
        if (!data?.activities?.financing?.transactions) return 0;

        return data.activities.financing.transactions
            .filter(t => !t.is_inflow &&
                !matchesCategory(t, CATEGORY_GROUPS.DRAWINGS, false, false, false, false, true) &&
                !matchesCategory(t, CATEGORY_GROUPS.CAPITAL, false, false, false, true, false)
            )
            .reduce((sum, t) => sum + t.amount, 0);
    };

    // Calculate sale of assets (Investing inflows)
    const calculateSaleOfAssets = () => {
        if (!data?.activities?.investing?.transactions) return 0;

        return data.activities.investing.transactions
            .filter(t => t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.FIXED_ASSETS, false, false, true))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    // Calculate purchase of assets (Investing outflows)
    const calculatePurchaseOfAssets = () => {
        if (!data?.activities?.investing?.transactions) return 0;

        return data.activities.investing.transactions
            .filter(t => !t.is_inflow && matchesCategory(t, CATEGORY_GROUPS.FIXED_ASSETS, false, false, true))
            .reduce((sum, t) => sum + t.amount, 0);
    };

    // Format amount with proper sign
    const formatAmount = (amount) => {
        const numAmount = parseFloat(amount || 0);
        const formatted = Math.abs(numAmount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        if (numAmount >= 0) {
            return formatted;
        } else {
            return `(${formatted})`;
        }
    };

    // Get amount display class
    const getAmountClass = (amount) => {
        const numAmount = parseFloat(amount || 0);
        if (numAmount > 0) return 'text-success';
        if (numAmount < 0) return 'text-danger';
        return 'text-muted';
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchCashFlowStatement();
    };

    const handleClear = () => {
        setFilters({
            start_date: '',
            end_date: '',
            project_id: '',
            include_non_cash: false,
            dateRange: 'yearly'
        });
        setSelectedYear(null);
        setSelectedEndYear(null);
        setData(null);
    };

    const handleExportPdf = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const params = {
                start_date: filters.start_date,
                end_date: filters.end_date,
                project_id: filters.project_id,
                include_non_cash: filters.include_non_cash
            };

            const response = await axios.get(`${backendUrl}/api/balancesheet/export-cashflow-pdf`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Accept': 'application/pdf'
                },
                params,
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            saveAs(blob, `CashFlowStatement_${filters.start_date || 'All'}_to_${filters.end_date || 'All'}.pdf`);
        } catch (err) {
            console.error('PDF Export Error:', err);
            setError('Failed to download PDF file. Please try again.');
        }
    };

    const handleExport = async (formatType) => {
        try {
            const params = new URLSearchParams();
            if (filters.start_date) params.append('start_date', filters.start_date);
            if (filters.end_date) params.append('end_date', filters.end_date);
            if (filters.project_id) params.append('project_id', filters.project_id);
            params.append('format', formatType);

            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const token = userInfo?.token;

            const response = await axios.get(
                `${API_ORIGIN}/api/reports/cashflow`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept': 'application/octet-stream'
                    },
                    params,
                    responseType: 'blob'
                }
            );
            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            const extension = formatType === 'csv' ? 'csv' : 'xls';
            saveAs(blob, `cash_flow_statement_${filters.start_date || 'start'}_to_${filters.end_date || 'end'}.${extension}`);
        } catch (err) {
            setError(`Failed to export ${formatType.toUpperCase()}`);
            console.error('Export Error:', err);
        }
    };

    return (
        <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="mb-0 text-primary">Cash Flow Statement</h4>
                                    <p className="text-muted mb-0 small">
                                        Shows actual cash movement
                                    </p>
                                </div>
                                <div className="d-flex gap-2">
                                    <button
                                        onClick={handleExportPdf}
                                        className="btn btn-outline-danger btn-sm"
                                        disabled={loading || !data}
                                    >
                                        <i className="fas fa-file-pdf me-1"></i>
                                        Export PDF
                                    </button>
                                    {/* <button
                                        onClick={() => handleExport('csv')}
                                        className="btn btn-outline-primary btn-sm"
                                        disabled={loading || !data}
                                    >
                                        <i className="fas fa-file-csv me-1"></i> CSV
                                    </button>
                                    <button
                                        onClick={() => handleExport('xls')}
                                        className="btn btn-outline-success btn-sm"
                                        disabled={loading || !data}
                                    >
                                        <i className="fas fa-file-excel me-1"></i> Excel
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card shadow-sm">
                                <div className="card-header bg-white border-bottom">
                                    <h5 className="card-title mb-0 text-primary">
                                        <i className="fas fa-money-bill-wave me-2"></i>
                                        Cash Flow Statement
                                    </h5>
                                </div>

                                <div className="card-body">
                                    <form onSubmit={handleSubmit} className="mb-4">
                                        <div className="row g-3">
                                            <div className="col-md-2">
                                                <label className="form-label text-muted small mb-1">Date Range</label>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={filters.dateRange}
                                                    onChange={(e) => handleDateRangeChange(e.target.value)}
                                                >
                                                    <option value="yearly">Yearly</option>
                                                    <option value="custom">Custom Range</option>
                                                </select>
                                            </div>

                                            {filters.dateRange === 'yearly' && (
                                                <>
                                                    <div className="col-lg-2 col-md-3">
                                                        <label className="form-label font-size-12 text-uppercase fw-bold text-muted mb-1">Start Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                openTo="year"
                                                                format="DD-MM-YYYY"
                                                                value={filters.start_date ? dayjs(filters.start_date) : null}
                                                                onChange={(newValue) => {
                                                                    if (newValue) {
                                                                        setSelectedYear(newValue);
                                                                        const dateStr = newValue.format('YYYY-MM-DD');
                                                                        if (!filters.start_date || dayjs(filters.start_date).year() !== newValue.year()) {
                                                                            const start = newValue.startOf('year');
                                                                            const end = newValue.endOf('year');
                                                                            setFilters(prev => ({
                                                                                ...prev,
                                                                                start_date: start.format('YYYY-MM-DD'),
                                                                                end_date: end.format('YYYY-MM-DD')
                                                                            }));
                                                                            setSelectedEndYear(newValue);
                                                                        } else {
                                                                            setFilters(prev => {
                                                                                const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, prev.end_date);
                                                                                const newFilters = { ...prev, start_date: newStart };
                                                                                if (suggestedEndDate) {
                                                                                    newFilters.end_date = suggestedEndDate;
                                                                                }
                                                                                return newFilters;
                                                                            });
                                                                        }
                                                                    }
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                    <div className="col-lg-2 col-md-3">
                                                        <label className="form-label font-size-12 text-uppercase fw-bold text-muted mb-1">End Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                openTo="year"
                                                                format="DD-MM-YYYY"
                                                                value={filters.end_date ? dayjs(filters.end_date) : null}
                                                                onChange={(newValue) => {
                                                                    if (newValue) {
                                                                        setSelectedEndYear(newValue);
                                                                        if (!filters.end_date || dayjs(filters.end_date).year() !== newValue.year()) {
                                                                            setFilters(prev => ({ ...prev, end_date: newValue.endOf('year').format('YYYY-MM-DD') }));
                                                                        } else {
                                                                            setFilters(prev => {
                                                                                return { ...prev, end_date: getAdjustedEndDate(newValue, prev.start_date) };
                                                                            });
                                                                        }
                                                                    }
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </>
                                            )}

                                            {filters.dateRange === 'custom' && (
                                                <>
                                                    <div className="col-md-2">
                                                        <label className="form-label text-muted small mb-1">From Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                format="DD-MM-YYYY"
                                                                value={filters.start_date ? dayjs(filters.start_date) : null}
                                                                onChange={(newValue) => {
                                                                    const dateStr = newValue ? newValue.format('YYYY-MM-DD') : '';
                                                                        setFilters(prev => {
                                                                            const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, prev.end_date);
                                                                            const newFilters = { ...prev, start_date: newStart };
                                                                            if (suggestedEndDate) {
                                                                                newFilters.end_date = suggestedEndDate;
                                                                            }
                                                                            return newFilters;
                                                                        });
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label className="form-label text-muted small mb-1">To Date</label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                views={["year", "month", "day"]}
                                                                format="DD-MM-YYYY"
                                                                value={filters.end_date ? dayjs(filters.end_date) : null}
                                                                onChange={(newValue) => {
                                                                        setFilters(prev => {
                                                                            return { ...prev, end_date: getAdjustedEndDate(newValue, prev.start_date) };
                                                                        });
                                                                }}
                                                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </>
                                            )}

                                            <div className="col-md-3">
                                                <label className="form-label text-muted small mb-1">Project (Optional)</label>
                                                <Select
                                                    options={projects}
                                                    value={projects.find(option => option.value === filters.project_id)}
                                                    onChange={(selected) => setFilters({ ...filters, project_id: selected?.value || '' })}
                                                    isClearable
                                                    placeholder="Select Project..."
                                                    className="border-primary"
                                                    styles={{ control: (base) => ({ ...base, minHeight: '38px' }) }}
                                                />
                                            </div>

                                            <div className="col-md-12 mt-3">
                                                <button type="submit" className="btn btn-primary me-2 px-4" disabled={loading || !filters.start_date || !filters.end_date}>
                                                    {loading ? (<><span className="spinner-border spinner-border-sm me-1" role="status"></span>Generating...</>) : (<><i className="fas fa-chart-line me-1"></i>Generate Cash Flow</>)}
                                                </button>
                                                <button type="button" className="btn btn-outline-secondary px-4" onClick={handleClear} disabled={loading}>
                                                    <i className="fas fa-eraser me-1"></i>Clear
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    {error && (<div className="alert alert-danger alert-dismissible fade show" role="alert"><i className="fas fa-exclamation-circle me-2"></i>{error}<button type="button" className="btn-close" onClick={() => setError(null)}></button></div>)}

                                    {loading && !data && (<div className="text-center py-5"><div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status"><span className="visually-hidden">Loading...</span></div><p className="mt-3 text-muted">Analyzing cash movements...</p></div>)}

                                    {!loading && data && (
                                        <div className="mt-4">
                                            {/* Period Info */}
                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                <div>
                                                    <h5 className="text-primary mb-1">
                                                        <i className="fas fa-calendar-alt me-2"></i>
                                                        Cash Flow Statement
                                                    </h5>
                                                    <div className="text-muted small">
                                                        Period: {filters.start_date && filters.end_date ? (
                                                            dayjs(filters.start_date).isSame(dayjs(filters.end_date).startOf('year'), 'day') && dayjs(filters.end_date).isSame(dayjs(filters.start_date).endOf('year'), 'day') ? (
                                                                `Jan ${dayjs(filters.start_date).format('YYYY')} - Dec ${dayjs(filters.end_date).format('YYYY')}`
                                                            ) : (
                                                                `${dayjs(filters.start_date).format('DD-MM-YYYY')} - ${dayjs(filters.end_date).format('DD-MM-YYYY')}`
                                                            )
                                                        ) : 'All Time Period'}
                                                    </div>
                                                </div>
                                                <div className={`badge ${data?.summary?.net_cash_flow >= 0 ? 'bg-success' : 'bg-danger'}`}>
                                                    Net Cash Flow: {formatAmount(data?.summary?.net_cash_flow || 0)}
                                                </div>
                                            </div>

                                            {/* Cash Flow Summary Cards */}
                                            <div className="row mb-4">
                                                <div className="col-md-3">
                                                    <div className="card border">
                                                        <div className="card-body p-3 text-center">
                                                            <h6 className="card-title text-muted small mb-1">Opening Cash</h6>
                                                            <div className={`h4 mb-0 ${getAmountClass(data?.summary?.opening_balance)}`}>
                                                                {formatAmount(data?.summary?.opening_balance || 0)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card border">
                                                        <div className="card-body p-3 text-center">
                                                            <h6 className="card-title text-muted small mb-1"><span className="badge bg-light me-1">A</span> Operating</h6>
                                                            <div className={`h4 mb-0 ${getAmountClass(data?.activities?.operating?.total)}`}>
                                                                {formatAmount(data?.activities?.operating?.total || 0)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card border">
                                                        <div className="card-body p-3 text-center">
                                                            <h6 className="card-title text-muted small mb-1"><span className="badge bg-light me-1">B</span> Investing</h6>
                                                            <div className={`h4 mb-0 ${getAmountClass(data?.activities?.investing?.total)}`}>
                                                                {formatAmount(data?.activities?.investing?.total || 0)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="card border">
                                                        <div className="card-body p-3 text-center">
                                                            <h6 className="card-title text-muted small mb-1"><span className="badge bg-light me-1">C</span> Financing</h6>
                                                            <div className={`h4 mb-0 ${getAmountClass(data?.activities?.financing?.total)}`}>
                                                                {formatAmount(data?.activities?.financing?.total || 0)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Detailed Cash Flow Statement */}
                                           {/* Detailed Cash Flow Statement */}
<div className="table-responsive">
  <table className="table table-bordered align-middle mb-0" style={{ fontSize: '14px' }}>
    <thead className="table-sales-gradient">
      <tr>
        <th style={{ width: '5%' }} className="text-center">#</th>
        <th style={{ width: '65%' }}>Particulars</th>
        <th style={{ width: '15%' }} className="text-end">Amount</th>
        <th style={{ width: '15%' }} className="text-end">Sub-Total</th>
      </tr>
    </thead>
    <tbody>
      {/* OPENING BALANCE - Level 0 Style */}
      <tr className="fw-bold" style={{ backgroundColor: '#f8f9fa' }}>
        <td className="text-center">-</td>
        <td className="text-uppercase">Opening Cash & Bank Balance</td>
        <td></td>
        <td className="text-end border-start border-2">{formatAmount(data?.summary?.opening_balance || 0)}</td>
      </tr>

      {/* OPERATING ACTIVITIES HEADER - Level 0 */}
      <tr className="fw-bold" style={{ backgroundColor: '#eee' }}>
        <td className="text-center">A</td>
        <td className="text-uppercase">CASH FLOW FROM OPERATING ACTIVITIES</td>
        <td></td>
        <td></td>
      </tr>

   
      
      {/* Receipts Details - Level 2 */}
      {calculateCashFromCustomers() !== 0 ? (
        <tr>
          <td className="text-center">1</td>
          <td className="ps-5 text-secondary">Cash received from Customers/Debtors</td>
          <td className="text-end text-success">{formatAmount(calculateCashFromCustomers())}</td>
          <td className="border-start border-2"></td>
        </tr>
      ) : (
        <tr>
          <td className="text-center">1</td>
          <td className="ps-5 text-muted fst-italic">No cash receipts from operations</td>
          <td className="text-end text-muted">-</td>
          <td className="border-start border-2"></td>
        </tr>
      )}

   

  

      {/* Payment Details - Level 2 */}
      {calculateCashToEmployees() !== 0 && (
        <tr>
          <td className="text-center">2</td>
          <td className="ps-5 text-secondary">Payments to Employees (Salaries, Wages)</td>
          <td className="text-end text-danger">({formatAmount(calculateCashToEmployees())})</td>
          <td className="border-start border-2"></td>
        </tr>
      )}

      {calculateCashToSuppliers() !== 0 && (
        <tr>
          <td className="text-center">3</td>
          <td className="ps-5 text-secondary">Payments to Suppliers/Creditors</td>
          <td className="text-end text-danger">({formatAmount(calculateCashToSuppliers())})</td>
          <td className="border-start border-2"></td>
        </tr>
      )}

      {/* Net Section Total - Bold Border like PDF */}
      <tr className="fw-bold" style={{ backgroundColor: '#fffde7', borderTop: '2px solid #000' }}>
        <td></td>
        <td className="text-end text-uppercase">Net Cash from Operating Activities (A)</td>
        <td></td>
        <td className="text-end border-start border-2 text-primary">
          {formatAmount(data?.activities?.operating?.total || 0)}
        </td>
      </tr>

      {/* INVESTING ACTIVITIES HEADER - Level 0 */}
      <tr className="fw-bold" style={{ backgroundColor: '#eee', borderTop: '2px solid #dee2e6' }}>
        <td className="text-center">B</td>
        <td className="text-uppercase">CASH FLOW FROM INVESTING ACTIVITIES</td>
        <td></td>
        <td></td>
      </tr>

      {/* Investing Items - Level 2 */}
      <tr>
        <td className="text-center">4</td>
        <td className="ps-4">Sale of Fixed Assets/Investments</td>
        <td className="text-end text-success">{formatAmount(calculateSaleOfAssets() || 0)}</td>
        <td className="border-start border-2"></td>
      </tr>
      <tr>
        <td className="text-center">5</td>
        <td className="ps-4">Purchase of Fixed Assets/Investments</td>
        <td className="text-end text-danger">({formatAmount(calculatePurchaseOfAssets() || 0)})</td>
        <td className="border-start border-2"></td>
      </tr>

      <tr className="fw-bold" style={{ backgroundColor: '#fffde7' }}>
        <td></td>
        <td className="text-end text-uppercase">Net Cash from Investing Activities (B)</td>
        <td></td>
        <td className="text-end border-start border-2 text-success">
          {formatAmount(data?.activities?.investing?.total || 0)}
        </td>
      </tr>

      {/* FINANCING ACTIVITIES HEADER - Level 0 */}
      <tr className="fw-bold" style={{ backgroundColor: '#eee' }}>
        <td className="text-center">C</td>
        <td className="text-uppercase">CASH FLOW FROM FINANCING ACTIVITIES</td>
        <td></td>
        <td></td>
      </tr>

      {/* Financing Items - Level 2 */}
      <tr>
        <td className="text-center">6</td>
        <td className="ps-4">Capital/Loans Movement (Net)</td>
        <td className="text-end">{formatAmount(calculateCapitalIntroduced() - calculateDrawings())}</td>
        <td className="border-start border-2"></td>
      </tr>

      <tr className="fw-bold" style={{ backgroundColor: '#fffde7' }}>
        <td></td>
        <td className="text-end text-uppercase">Net Cash from Financing Activities (C)</td>
        <td></td>
        <td className="text-end border-start border-2 text-info">
          {formatAmount(data?.activities?.financing?.total || 0)}
        </td>
      </tr>

      {/* FINAL TOTALS - Double Border Style */}
      <tr className="fw-bold table-white">
        <td className="text-center">10</td>
        <td className="text-uppercase">Net Increase/(Decrease) in Cash (A+B+C)</td>
        <td></td>
        <td className="text-end">
          {formatAmount(data?.summary?.net_cash_flow || 0)}
        </td>
      </tr>

      <tr className="fw-bold" style={{ backgroundColor: '#e8f5e9', borderTop: '2px solid #2e7d32' }}>
        <td className="text-center">11</td>
        <td className="text-uppercase">Closing Cash & Bank Balance</td>
        <td></td>
        <td className="text-end" style={{ fontSize: '1.1rem' }}>
          {formatAmount(data?.summary?.closing_balance || 0)}
        </td>
      </tr>
    </tbody>
  </table>
</div>

                                            {/* Transaction Details (Optional) */}
                                            {/* <div className="mt-4">
                                                <h6 className="text-primary mb-3">
                                                    <i className="fas fa-list me-2"></i>
                                                    Transaction Details
                                                </h6>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="card border mb-3">
                                                            <div className="card-header bg-light">
                                                                <h6 className="mb-0">Operating Activities</h6>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="list-group list-group-flush">
                                                                    {data?.activities?.operating?.transactions?.map((t, index) => (
                                                                        <div key={index} className="list-group-item">
                                                                            <div className="d-flex justify-content-between">
                                                                                <div>
                                                                                    <small className="text-muted">{t.date}</small><br/>
                                                                                    <span className={t.is_inflow ? 'text-success' : 'text-danger'}>
                                                                                        {t.counterparty_ledger}
                                                                                    </span>
                                                                                </div>
                                                                                <div className="text-end">
                                                                                    <span className={t.is_inflow ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                                                                                        {t.is_inflow ? '+' : '-'} {formatAmount(t.amount)}
                                                                                    </span><br/>
                                                                                    <small className="text-muted">{t.counterparty_group}</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="card border mb-3">
                                                            <div className="card-header bg-light">
                                                                <h6 className="mb-0">Financing Activities</h6>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="list-group list-group-flush">
                                                                    {data?.activities?.financing?.transactions?.map((t, index) => (
                                                                        <div key={index} className="list-group-item">
                                                                            <div className="d-flex justify-content-between">
                                                                                <div>
                                                                                    <small className="text-muted">{t.date}</small><br/>
                                                                                    <span className="text-success">{t.counterparty_ledger}</span>
                                                                                </div>
                                                                                <div className="text-end">
                                                                                    <span className="text-success fw-bold">+ {formatAmount(t.amount)}</span><br/>
                                                                                    <small className="text-muted">{t.counterparty_group}</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* {data?.debug_info && (
            <div className="card border mt-4">
                <div className="card-header bg-warning bg-opacity-10">
                    <h6 className="mb-0">
                        <i className="fas fa-bug me-2"></i>
                        Debug Information
                    </h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <h6>Group Configuration:</h6>
                            <ul className="list-unstyled">
                                <li><strong>Operating Groups:</strong> {data.debug_info.operating_groups?.join(', ') || 'None'}</li>
                                <li><strong>Investing Groups:</strong> {data.debug_info.investing_groups?.join(', ') || 'None'}</li>
                                <li><strong>Financing Groups:</strong> {data.debug_info.financing_groups?.join(', ') || 'None'}</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <h6>Categorized Counts:</h6>
                            <ul className="list-unstyled">
                                <li><strong>Operating:</strong> {data.debug_info.categorized_counts?.operating || 0} transactions</li>
                                <li><strong>Investing:</strong> {data.debug_info.categorized_counts?.investing || 0} transactions</li>
                                <li><strong>Financing:</strong> {data.debug_info.categorized_counts?.financing || 0} transactions</li>
                                <li><strong>Uncategorized:</strong> {data.debug_info.categorized_counts?.uncategorized || 0} transactions</li>
                            </ul>
                        </div>
                    </div>
                    
                    {data.debug_info.uncategorized_examples && data.debug_info.uncategorized_examples.length > 0 && (
                        <div className="mt-3">
                            <h6>Sample Uncategorized Transactions:</h6>
                            <div className="table-responsive">
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Counterparty</th>
                                            <th>Group</th>
                                            <th>Group ID</th>
                                            <th>Amount</th>
                                            <th>Narration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.debug_info.uncategorized_examples.map((t, index) => (
                                            <tr key={index}>
                                                <td>{t.date}</td>
                                                <td>{t.counterparty_ledger}</td>
                                                <td>{t.counterparty_group}</td>
                                                <td>{t.counterparty_group_id}</td>
                                                <td>{formatAmount(t.amount)}</td>
                                                <td className="small">{t.narration}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )} */}

                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashFlowStatement;
